// extracted by mini-css-extract-plugin
export default {"downloadButton":"FileDownloadButton_downloadButton__aXZAe","downloadIcon":"FileDownloadButton_downloadIcon__lblIY"};